export default __webpack_public_path__ + "static/grabpay-e5eef667657af43f72f140506725119f.svg";